module.exports = __webpack_public_path__ + "img/file-earmark-minus-fill.86533670.svg";